import React from 'react';
import { Delete, Edit } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

const alert_prior = ['BAJO', 'MEDIO', 'ALTO'];

export const getColumns = (handleDelete, handleEdit, intl) => [
  {
    field: 'name',
    headerName: intl.formatMessage({ id: 'app.alerts.grid.dateCol' }),
    flex: 1,
  },
  {
    field: 'message',
    headerName: 'Mensaje',
    flex: 1,
  },
  {
    field: 'lvl',
    headerName: 'Nivel',
    renderCell: (rowData) => {
      return alert_prior[rowData.row.lvl - 1] + ' ';
    },
    flex: 1,
  },
  {
    field: ' ',
    headerName: 'Action',
    flex: 1,
    renderCell: (rowData) => {
      return (
        <>
          <Tooltip title="Eliminar">
            <IconButton onClick={() => handleDelete(rowData.row)}>
              <Delete />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar">
            <IconButton onClick={() => handleEdit(rowData.row)}>
              <Edit />
            </IconButton>
          </Tooltip>
        </>
      );
    },
  },
];
